/**
 * V2Providers — Phase 5 (PRI-291)
 *
 * Nests the three V2 context providers. Using this wrapper means PrimateVisionV2
 * only needs to import one thing instead of three separate providers.
 */

import type { ReactNode } from 'react'
import { InferenceContextProvider, type InferenceContextValue } from '../../contexts/InferenceContext'
import { StreamContextProvider, type StreamContextValue } from '../../contexts/StreamContext'
import { VideoLibraryContextProvider, type VideoLibraryContextValue } from '../../contexts/VideoLibraryContext'

export interface V2ProviderValues {
  inference: InferenceContextValue
  stream: StreamContextValue
  videoLibrary: VideoLibraryContextValue
}

export function V2Providers({ children, values }: { children: ReactNode; values: V2ProviderValues }) {
  return (
    <InferenceContextProvider value={values.inference}>
      <StreamContextProvider value={values.stream}>
        <VideoLibraryContextProvider value={values.videoLibrary}>
          {children}
        </VideoLibraryContextProvider>
      </StreamContextProvider>
    </InferenceContextProvider>
  )
}
